/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationV2TeamSide } from './MatchOperationV2TeamSide';
import {
    MatchOperationV2TeamSideFromJSON,
    MatchOperationV2TeamSideFromJSONTyped,
    MatchOperationV2TeamSideToJSON,
    MatchOperationV2TeamSideToJSONTyped,
} from './MatchOperationV2TeamSide';

/**
 * 
 * @export
 * @interface MatchOperationV2ParticipantStatistics
 */
export interface MatchOperationV2ParticipantStatistics {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    participantId: string;
    /**
     * 
     * @type {MatchOperationV2TeamSide}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    teamSide: MatchOperationV2TeamSide;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    attempts: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    onTarget: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    offTarget: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    goals: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    missedConversions: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    shotsFaced: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    saves: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    sevenMeterAttempts: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    sevenMeterGoals: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    sevenMeterShotsFaced: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    sevenMeterSaves: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    posts: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    blockedShots: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    blocks: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    turnovers: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    technicalFaults: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ParticipantStatistics
     */
    lostBalls: number;
}



/**
 * Check if a given object implements the MatchOperationV2ParticipantStatistics interface.
 */
export function instanceOfMatchOperationV2ParticipantStatistics(value: object): value is MatchOperationV2ParticipantStatistics {
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('teamSide' in value) || value['teamSide'] === undefined) return false;
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    if (!('onTarget' in value) || value['onTarget'] === undefined) return false;
    if (!('offTarget' in value) || value['offTarget'] === undefined) return false;
    if (!('goals' in value) || value['goals'] === undefined) return false;
    if (!('missedConversions' in value) || value['missedConversions'] === undefined) return false;
    if (!('shotsFaced' in value) || value['shotsFaced'] === undefined) return false;
    if (!('saves' in value) || value['saves'] === undefined) return false;
    if (!('sevenMeterAttempts' in value) || value['sevenMeterAttempts'] === undefined) return false;
    if (!('sevenMeterGoals' in value) || value['sevenMeterGoals'] === undefined) return false;
    if (!('sevenMeterShotsFaced' in value) || value['sevenMeterShotsFaced'] === undefined) return false;
    if (!('sevenMeterSaves' in value) || value['sevenMeterSaves'] === undefined) return false;
    if (!('posts' in value) || value['posts'] === undefined) return false;
    if (!('blockedShots' in value) || value['blockedShots'] === undefined) return false;
    if (!('blocks' in value) || value['blocks'] === undefined) return false;
    if (!('turnovers' in value) || value['turnovers'] === undefined) return false;
    if (!('technicalFaults' in value) || value['technicalFaults'] === undefined) return false;
    if (!('lostBalls' in value) || value['lostBalls'] === undefined) return false;
    return true;
}

export function MatchOperationV2ParticipantStatisticsFromJSON(json: any): MatchOperationV2ParticipantStatistics {
    return MatchOperationV2ParticipantStatisticsFromJSONTyped(json, false);
}

export function MatchOperationV2ParticipantStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2ParticipantStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'participantId': json['participantId'],
        'teamSide': MatchOperationV2TeamSideFromJSON(json['teamSide']),
        'attempts': json['attempts'],
        'onTarget': json['onTarget'],
        'offTarget': json['offTarget'],
        'goals': json['goals'],
        'missedConversions': json['missedConversions'],
        'shotsFaced': json['shotsFaced'],
        'saves': json['saves'],
        'sevenMeterAttempts': json['sevenMeterAttempts'],
        'sevenMeterGoals': json['sevenMeterGoals'],
        'sevenMeterShotsFaced': json['sevenMeterShotsFaced'],
        'sevenMeterSaves': json['sevenMeterSaves'],
        'posts': json['posts'],
        'blockedShots': json['blockedShots'],
        'blocks': json['blocks'],
        'turnovers': json['turnovers'],
        'technicalFaults': json['technicalFaults'],
        'lostBalls': json['lostBalls'],
    };
}

export function MatchOperationV2ParticipantStatisticsToJSON(json: any): MatchOperationV2ParticipantStatistics {
    return MatchOperationV2ParticipantStatisticsToJSONTyped(json, false);
}

export function MatchOperationV2ParticipantStatisticsToJSONTyped(value?: MatchOperationV2ParticipantStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participantId': value['participantId'],
        'teamSide': MatchOperationV2TeamSideToJSON(value['teamSide']),
        'attempts': value['attempts'],
        'onTarget': value['onTarget'],
        'offTarget': value['offTarget'],
        'goals': value['goals'],
        'missedConversions': value['missedConversions'],
        'shotsFaced': value['shotsFaced'],
        'saves': value['saves'],
        'sevenMeterAttempts': value['sevenMeterAttempts'],
        'sevenMeterGoals': value['sevenMeterGoals'],
        'sevenMeterShotsFaced': value['sevenMeterShotsFaced'],
        'sevenMeterSaves': value['sevenMeterSaves'],
        'posts': value['posts'],
        'blockedShots': value['blockedShots'],
        'blocks': value['blocks'],
        'turnovers': value['turnovers'],
        'technicalFaults': value['technicalFaults'],
        'lostBalls': value['lostBalls'],
    };
}

